module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    class: {
      english: _vm.$i18n.locale == 'en'
    }
  }, [_c('headLine', {
    ref: "dialog",
    attrs: {
      "index": "3",
      "showbar": "true"
    },
    on: {
      "on-locale-change": _vm.onLocaleChange
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('product.name')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "banner banner1"
  }, [_c('img', {
    attrs: {
      "src": _vm.imglist[0],
      "alt": ""
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "banner_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('product.banner_text'))
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "banner_title banner_title1",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('product.banner_text2'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center button_banner",
    staticStyle: {
      "position": "absolute",
      "top": "4.02rem",
      "width": "100%"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/software"
    }
  }, [_c('a', {
    staticClass: "button_default",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('product.banner_botton'))
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content center"
  }, [_c('div', {
    staticClass: "content_item content_item2"
  }, [_c('h3', {
    staticClass: "content_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('product.introduction_title'))
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[2]),
      expression: "imglist[2]"
    }],
    staticStyle: {
      "width": "100%",
      "height": "3.38rem"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content_item_text"
  }, [_vm._v(_vm._s(_vm.$t('product.introduction_text13')) + "\n")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[3]),
      expression: "imglist[3]"
    }],
    staticStyle: {
      "width": "100%",
      "height": "3.38rem"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content_item_text"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('product.introduction_text11')) + "\n        ")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[4]),
      expression: "imglist[4]"
    }],
    staticStyle: {
      "width": "100%",
      "height": "3.38rem"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content_item_text",
    staticStyle: {
      "margin-bottom": "0.7rem"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('product.introduction_text12')) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "content center",
    staticStyle: {
      "background-color": "rgba(238,245,254,1)"
    }
  }, [_c('div', {
    staticClass: "content_item"
  }, [_c('h3', {
    staticClass: "content_item_title",
    staticStyle: {
      "margin-bottom": "0.25rem"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('product.introduction_title2'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content_item_text"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('product.introduction_text2')) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "content_item_text"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('product.introduction_text21')) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "content_item_text"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('product.introduction_text22')) + "\n          ")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[5]),
      expression: "imglist[5]"
    }],
    staticStyle: {
      "width": "7.25rem",
      "height": "6.56rem",
      "margin": "0 auto",
      "margin-top": "-0.2rem",
      "padding-bottom": "0.4rem"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "content center"
  }, [_c('div', {
    staticClass: "content_item"
  }, [_c('h3', {
    staticClass: "content_item_title",
    staticStyle: {
      "margin-bottom": "0.25rem"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('product.introduction_title4'))
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h5', {
    staticClass: "content_item_text2"
  }, [_vm._v(_vm._s(_vm.$t('product.introduction_title5')))]), _vm._v(" "), _c('a', {
    staticClass: "button_default button_default2",
    staticStyle: {
      "margin-bottom": "0.7rem"
    },
    on: {
      "click": function($event) {
        _vm.showDialog()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('product.text45')))])])])]), _vm._v(" "), _c('footerLine')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "platformList clearfix"
  }, [_c('li', [_c('span', {
    staticClass: "mult_platform"
  })]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "mult_platform1"
  })]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "mult_platform2"
  })]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "mult_platform3"
  })]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "mult_platform4"
  })]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "mult_platform5"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67a42eac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/product1.vue
// module id = 96
// module chunks = 0